import { venueCategories, type CategoryQuality, type Venue, type VenueCategory } from "./types.js";

export function hasOfficialWebsite(value: string | undefined): boolean {
  if (!value) return false;
  try {
    const url = new URL(value);
    return url.protocol === "https:" || url.protocol === "http:";
  } catch {
    return false;
  }
}

export function isWebsiteHoursEligible(venue: Venue): boolean {
  return (
    !venue.originalHours?.trim() && !venue.kitchenHours?.trim() && hasOfficialWebsite(venue.website)
  );
}

export function websiteHoursEligibleCount(venues: readonly Venue[]): number {
  return venues.filter(isWebsiteHoursEligible).length;
}

export function qualityByCategory(
  venues: readonly Venue[],
): Record<VenueCategory, CategoryQuality> {
  const quality = Object.fromEntries(
    venueCategories.map((category) => [category, { total: 0, withHours: 0, parsed: 0 }]),
  ) as Record<VenueCategory, CategoryQuality>;

  venues.forEach((venue) => {
    const category = quality[venue.category];
    category.total += 1;
    if (venue.schedule.status !== "missing") category.withHours += 1;
    if (venue.schedule.status === "parsed" || venue.schedule.status === "conditional") {
      category.parsed += 1;
    }
  });

  return quality;
}
